import React from 'react';
import {
  adminFetchPoliciesRequestAction,
  adminIsLoadedSelector,
  adminSetPoliciesAction,
  ChannelAccessPageView,
  extractPolicy,
  normalizedPoliciesSelector,
  PermissionElementAttrEnum,
  policiesSelector,
  rebuildPermissions,
  rebuildPolicies,
  rootChannelsSelector,
} from 'pages/administration.page';
import { permissionModel } from 'common/api/models/website';
import { connect } from 'react-redux';
import { websiteSelector } from 'common/selectors';
import { PermissionsEnum } from 'utils/permissions.enum';

export const ChannelAccessPage = connect(
  (state) => ({
    website: websiteSelector(state),
    policies: policiesSelector(state),
    normalizedPolicies: normalizedPoliciesSelector(state),
    rootChannels: rootChannelsSelector(state),
    adminIsLoaded: adminIsLoadedSelector(state),
  }),
  (dispatch) => ({
    getPolicies: (websiteId) => dispatch(adminFetchPoliciesRequestAction(websiteId)),
    setPolicies: (policies) => dispatch(adminSetPoliciesAction(policies)),
  })
)(
  class extends React.Component {
    componentDidMount() {
      if (!this.props.adminIsLoaded) this.props.getPolicies(this.props.website.id);
    }

    onChannelRightChange = (event) => {
      const policyId = +event.target.getAttribute(PermissionElementAttrEnum.POLICY_ID);
      const dataIndexKey = `${PermissionsEnum.CHANNEL_ACCESS}_${policyId}`;
      const channelId = +event.target.value;

      const currentData =
        this.props.normalizedPolicies[dataIndexKey] instanceof Array ? this.props.normalizedPolicies[dataIndexKey] : [];
      let newData = null;

      if (currentData.indexOf(channelId) > -1 && !event.target.checked) {
        // remove it from allowed channels
        newData = currentData.filter((channel_id) => channel_id !== channelId);
      } else if (currentData.indexOf(channelId) === -1 && event.target.checked) {
        // add to list of allowed channels
        newData = [...currentData, channelId];
      }

      const currentPolicy = extractPolicy(this.props.policies, policyId);

      const policies = rebuildPolicies(this.props.policies, {
        ...currentPolicy,
        permissions: rebuildPermissions(
          currentPolicy.permissions,
          permissionModel({
            name: PermissionsEnum.CHANNEL_ACCESS,
            data: newData,
          })
        ),
      });

      // Set policies in store
      this.props.setPolicies(policies);
    };

    render() {
      return (
        <ChannelAccessPageView
          policies={this.props.policies || []}
          onChannelRightChange={this.onChannelRightChange}
          rootChannels={this.props.rootChannels}
        />
      );
    }
  }
);
